import { reactive, ref, watchEffect } from 'vue'
import { createID, getValueByPath, post, setValueByPath } from '../../../utils/index'
import { useTemplate } from '../../../hooks/index'
import { useMergeCell } from './use-merge-cell'
export function useData(props, tableRef, tableData, columnList, tableConfig, emit) {
  const page = reactive({
    pageNo: 1,
    pageSize: props.pageSize,
  })
  let isAsync = false
  const onChange = (type) => {
    if (props.dataUrl) {
      getData()
    } else if (isAsync) {
      type === 'size' ? emit('size-change', page.pageSize) : emit('current-change', page.pageNo)
    } else {
      loadPageData()
    }
  }
  const sizeChange = () => {
    onChange('size')
  }
  const currentChange = () => {
    onChange()
  }

  const { mergeCells, getMergeCell, ifMergeCells } = useMergeCell({
    tableConfig,
    isSelection: props.props,
    isIconSelection: props.isIconSelection,
    seqShow: props.seqShow,
  })
  const tableLoadData = (data, init = true) => {
    getMergeCell({ data, columnList: columnList.value })
    if (!init || (!props.height && !props.maxHeight)) {
      return ifMergeCells
        ? tableRef.value
            ?.loadData?.(data)
            ?.then(() => tableRef.value?.setMergeCells?.(mergeCells.value))
        : tableRef.value?.loadData?.(data)
    } else {
      //将滚动条置为初始状态
      tableRef.value?.loadData?.([])
      return new Promise((resolve) => {
        setTimeout(() => {
          if (ifMergeCells) {
            tableRef.value
              ?.loadData?.(data)
              ?.then(() => tableRef.value?.setMergeCells?.(mergeCells.value))
          } else {
            tableRef.value?.loadData?.(data)
          }
          resolve()
        })
      })
    }
  }

  const totalCount = ref(0)
  //处理表格渲染的数据
  const loadPageData = (initPageNo = false) => {
    if (initPageNo) {
      page.pageNo = 1
    }
    totalCount.value = tableData.value.length
    const pageData = props.showPagination
      ? tableData.value.slice((page.pageNo - 1) * page.pageSize, page.pageNo * page.pageSize)
      : tableData.value
    return tableLoadData(pageData, !props.scrollBar)
  }

  //内部搜索时
  const seachData = (data) => {
    page.pageNo = 1
    totalCount.value = data.length
    const pageData = props.showPagination
      ? data.slice((page.pageNo - 1) * page.pageSize, page.pageNo * page.pageSize)
      : data
    return tableLoadData(pageData, !props.scrollBar)
  }

  const total = ref(null)
  const loadPageDataAsync = (data) => {
    isAsync = true
    totalCount.value = data.totalCount ?? 0
    total.value = data.total ?? null
    emit('loaded-async', tableData.value)

    return tableLoadData(tableData.value, props.scrollBar)
  }

  const getData = async (seachValue) => {
    if (!props.dataUrl) return
    const param = {
      pageNo: page.pageNo,
      pageSize: page.pageSize,
      tableCode: props.columnTableCode,
      ...props.dataParameters,
    }
    setValueByPath(param, 'parameters.keyword', seachValue)
    const [resData] = await post(props.dataUrl, param)
    tableData.value = creatRowId(resData?.data) ?? []
    loadPageDataAsync(resData ?? {})
  }
  watchEffect(getData)

  const creatRowId = (data, _PARENT) => {
    if (props.rowConfig?.keyField && !props.checkboxConfig?.checkField) {
      return data
    }
    if (!data?.length) return data
    for (let item of data) {
      if (!props.rowConfig?.keyField) {
        item._ID = item._ID ?? createID()
      }
      if (props.checkboxConfig?.checkField) {
        item[props.checkboxConfig.checkField] = false
      }
      if (item.children) {
        item.children = creatRowId(
          item.children,
          getValueByPath(item, props.rowConfig?.keyField ?? '_ID')
        )
      }
      if (_PARENT) {
        setValueByPath(item, props.treeConfig?.parentField ?? '_PARENT', _PARENT)
      }
    }
    return data
  }

  ////解决由于数据量大时并且滚动之后导致表格数据都被vue监听在缓存时占用空间大
  const clearOb = (data) => {
    tableData.value = props.dataUrl ? JSON.parse(JSON.stringify(tableData.value)) : data
    if (isAsync) {
      tableLoadData(tableData.value).then(() => {
        //解决点击单元格跳转到其他页面时tooltip还在页面展示
        setTimeout(() => {
          tableRef.value?.closeTooltip?.()
        })
      })
      emit('loaded-async', tableData.value)
    } else {
      const pageData = props.showPagination
        ? tableData.value.slice((page.pageNo - 1) * page.pageSize, page.pageNo * page.pageSize)
        : tableData.value
      tableLoadData(pageData).then(() => {
        setTimeout(() => {
          tableRef.value?.closeTooltip?.()
        })
      })
    }
  }

  //树级时判断是否是顶层
  const isTopFloor = (row) => {
    return !getValueByPath(row, props.treeConfig?.parentField ?? '_PARENT')
  }
  //rowClassName 处理 errorRow
  const rowClassName = ({ row }) => {
    let rowClassNameString = ''
    if (!!props.treeNode && isTopFloor(row)) {
      rowClassNameString += 'pg-table__table--color-row '
    }
    const { compileData, getTemplateData } = useTemplate()
    const compile = getTemplateData(row, props.extendCompileData)
    if (props.errorRow) {
      const res = compileData(`{{${props.errorRow}}}`, compile)
      if (res) rowClassNameString += 'error-row '
    }
    if (props.currentRow) {
      const res = compileData(`{{${props.currentRow}}}`, compile)
      if (res) rowClassNameString += 'rows--current'
    }

    return rowClassNameString
  }

  return {
    rowClassName, // 为行添加的一些样式
    page, //分页参数
    totalCount, //总条数
    sizeChange, //分页 每页显示条数变化事件
    currentChange, // 分页  当前页变化事件
    loadPageData, // 加载表格数据
    total, // 接口返回表格数据的列合计数据
    loadPageDataAsync, // 表格数据是异步时加载表格数据
    creatRowId, // 创建表格数据行id
    clearOb,
    getData,
    seachData,
    isTopFloor,
    mergeCells,
  }
}
